import clsx from 'clsx'
import React from 'react'
import { Logger } from 'wdc-cube'
import { bindUpdate } from 'wdc-cube-react'

import { makeStyles } from 'tss-react/mui'

import { Divider, FormControl, InputLabel, MenuItem, Paper, Select } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import { classToFComponent, FCClassContext } from 'src/utils/views'
import IntegracaoMonitoramentoFormScope from '../integracao-monitoramento_form.scopes'
import { MonitoramentoRow } from '../../integracao-monitoramento.types'

const LOG = Logger.get('INTEGRACA-MONITORAMENTO-FORM-VIEW')

const useStyles = makeStyles()({
    view: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        padding: 10,
        minHeight: 600,
        rowGap: 10
    },
    cnpjInput: {
        flexGrow: 1
    }
})

type IntegracaoMonitoramentoFormViewProps = {
    className?: string
    scope: IntegracaoMonitoramentoFormScope
}
class IntegracaoMonitoramentoFormViewClass implements FCClassContext<IntegracaoMonitoramentoFormViewProps> {
    // :: Fields
    scope!: IntegracaoMonitoramentoFormScope
    sytles!: ReturnType<typeof useStyles>

    // :: emissors

    readonly emitOnSave = () => {
        this.scope.onSave().catch(LOG.caught)
    }

    readonly emitOnClose = () => {
        this.scope.onClose().catch(LOG.caught)
    }

    readonly emitFormDataChange = (dadosAlterados: Partial<MonitoramentoRow>) => {
        this.scope.onFormDataChange(dadosAlterados).catch(LOG.caught)
    }

    // :: Methods

    onSyncState({ scope }: IntegracaoMonitoramentoFormViewProps) {
        this.scope = scope
        this.sytles = useStyles()
    }

    render({ className, scope }: IntegracaoMonitoramentoFormViewProps) {
        this.scope = bindUpdate(React, scope)

        const classes = this.sytles.classes

        return (
            <div className={clsx(classes.view, className)}>
                <Paper elevation={3} style={{ padding: 10 }}>
                    <Box display="flex" flexDirection="row" alignItems="baseline" gap="10px" marginBottom="20px">
                        <TextField
                            className={classes.cnpjInput}
                            value={scope.formData.doc}
                            onChange={(evt) =>
                                this.emitFormDataChange({
                                    doc: evt.target.value
                                })
                            }
                            label="Documento"
                            variant="standard"
                        />
                        <FormControl>
                            <InputLabel id="tipo-select-label">Tipo</InputLabel>
                            <Select
                                labelId="tipo-select-label"
                                id="tipo-select"
                                value={scope.formData.tipo}
                                label="Tipo"
                                onChange={(evt) =>
                                    this.emitFormDataChange({
                                        tipo: evt.target.value as 'BLOQUEADO' | 'MONITORADO_VISAO_CEDENTE' | undefined
                                    })
                                }
                            >
                                <MenuItem value={'BLOQUEADO'}>Bloqueado</MenuItem>
                                <MenuItem value={'MONITORADO_VISAO_CEDENTE'}>Monitorado Visão Cedente</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                    {this.scope.formData.tipo === 'MONITORADO_VISAO_CEDENTE' && (
                        <Box display="flex" flexDirection="row" alignItems="baseline" gap="10px" marginBottom="20px">
                            <FormControl>
                                <InputLabel id="grupo-select-label">Grupo</InputLabel>
                                <Select
                                    sx={{ minWidth: 300 }}
                                    labelId="grupo-select-label"
                                    id="grupo-select"
                                    label="Grupo"
                                    value={scope.formData.grupo_proc_id}
                                    full-width
                                    onChange={(evt) =>
                                        this.emitFormDataChange({
                                            grupo_proc_id: Number(evt.target.value)
                                        })
                                    }
                                >
                                    {this.scope.gruposAtivos.map((gp) => (
                                        <MenuItem key={gp.id} value={gp.id}>
                                            {gp.nome}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                    )}

                    <Divider />

                    <Box display="flex" flexDirection="row" alignItems="baseline" gap="10px" marginTop="10px">
                        <Button variant="outlined" onClick={this.emitOnSave}>
                            Salvar
                        </Button>
                        <Button variant="outlined" onClick={this.emitOnClose}>
                            Voltar
                        </Button>
                    </Box>
                </Paper>
            </div>
        )
    }
}

export const GrupoFormView = classToFComponent(IntegracaoMonitoramentoFormViewClass, React)
export default GrupoFormView
